export default __webpack_public_path__ + "static/media/iconEvents.c96fd7ed.svg";